const loaderDiv = document.getElementById("search-loader-bg"); // get the div element by its id
const closeicon = document.getElementById("clearSearchText");
const targetElement = document.getElementById('searchelement');

function get_games()
{
    return new Promise((resolve, reject) => {
        build_global_games_object()
        .then((ggo) => {
            update_UCC_masterObject({
                games:ggo.games,
            })
            rtgGames = ggo.games
            rtgGamesArray = Object.values(rtgGames)
            resolve({games:rtgGames}) //return this way to match future UCC response
        })
    })
}

function update_UCC_masterObject(data)
{
	let currentUCC = get_UCC_masterObject()
	let updatedUCC = {...currentUCC, ...data}
	localStorage.setItem('gameSearch', JSON.stringify(updatedUCC))
	return get_UCC_masterObject() //update global UCC variable
}


/**
 * Get the content of UCC master object (v)
 * (localStore keep values as string, so it requires JSON.parse to convert to object)
 * @return javascript object
 */
function get_UCC_masterObject()
{
	if (localStorage.getItem('gameSearch') === null) {
		//create UCC master object for first time
		localStorage.setItem('gameSearch',JSON.stringify({}))
	} else {
		return JSON.parse(localStorage.getItem('gameSearch'))
	}
}

function build_global_games_object()
{
    return new Promise((resolve, reject)=>{
        let tmp_rtgGames = {}
        let gameThemes = []
        let themesoutput = []

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const favorite_shortcut = urlParams.get('fav')

        fetch('/app/shared/controllers/GamesController.php?games')
		.then(response => response.json())
        .then((games) => {

            Object.values(games).forEach((g) => {
                let thisGame = build_game_object(g);
                tmp_rtgGames[g.uniqueID] = thisGame
            })
            resolve({
                games:tmp_rtgGames
            })
        })
        .catch((err) => {
            reject(err)
        })

    })
}

function build_game_object(rawGameElement)
{
	//basic game data
	let ranking = rawGameElement.ranking === 0 ? 1000 : rawGameElement.ranking

    let thisGame = {
		gameId: rawGameElement.gameID,
		machId: rawGameElement.machineID,
		name: rawGameElement.name,
		releaseDate: rawGameElement.release_date,
		uniqueId: rawGameElement.uniqueID,
		simplename: rawGameElement.simple_name,
        width: rawGameElement.width === 800 ? 1280 : rawGameElement.width,
		height: rawGameElement.height === 600 ? 720 : rawGameElement.height,
		category: rawGameElement.category,
		jackpot: rawGameElement.jackpot_amount,
		theme: rawGameElement.theme === '' ? rawGameElement.category : rawGameElement.theme,
        sub_groups: rawGameElement.sub_groups,
		featRanking: ranking,
        game_lock: rawGameElement.game_lock,
        isFavorite: rawGameElement.is_favorite
	}


	return thisGame
}

function onfirstLoad(){

    if (localStorage.getItem('gameSearch') === null) {
        //create UCC master object for first time
        get_games();
    } else {
        return JSON.parse(localStorage.getItem('gameSearch'));
    }
}
onfirstLoad();
/***********************SEarch************************/

function searchGames(search = null) {

    loaderDiv.style.display = "block"; // hide the div
    let x = document.getElementById("search"); let results = '';
    
    targetElement.innerHTML ='';
    searchkeyword= x.value.toLowerCase();
   // console.log(searchkeyword.length);
    if(searchkeyword.length > 0){
        closeicon.style.display = "block";
    }else{
        closeicon.style.display = "none"; 
    }
   
    var gamesList = onfirstLoad();
    const matchingGames = Object.values(gamesList.games).filter((game) => {
        return game.name.toLowerCase().includes(searchkeyword);
    });
    matchingGames.sort((a, b) => {
        const dateA = new Date(a.releaseDate);
        const dateB = new Date(b.releaseDate);
        return dateB - dateA; // sort in descending order
    });
    if (matchingGames.length === 0) {
        loaderDiv.style.display = "none"; // hide the div
        targetElement.innerHTML = "Sorry, there are no games matching your search keyword.";
        return;
    }
    const gameList = document.createElement("ul");
    matchingGames.forEach((game) => {
        real = WEBPLAY_PAGE+'?play='+game.simplename; 
        //demo = WEBPLAY_PAGE+'?play='+game.simplename+'&forreal=0';  
        const gameItem = document.createElement("li");
		gameItem.classList.add('gameimage');
        gameItem.innerHTML = '<div class="games-wrap"><a href="'+real+'"> <div class="s-card"><div class="s-card-head"><img src="'+ASSETSDOMAINJS+'/rtg/portrait/'+game.simplename+'.jpg" alt="'+game.name+'"></div><div class="s-card-body"><h2>'+game.name+'</h2><p>'+game.category+'</p></div></div></a>';
        gameList.appendChild(gameItem);
      
    });
    loaderDiv.style.display = "none"; // hide the div
    targetElement.appendChild(gameList);
}

////////////////////////////Show original stage of serach element 
function GamessearchLoad(){
    let games2 = '';
    var url = '/sections/SiteController.php?games=newgamesonsearch';
    fetch(url)
    .then((response) => response.json())
    .then((gameList) => {
        if (gameList.length) {
          //var gameList = JSON.parse(games);
          var lastparm = gameList.length;
          var games = ''; var real =''; var demo = ''; var i = 0;
          gameList.forEach((item, index) => {
            real = WEBPLAY_PAGE+'?play='+item.simple_name+'&forreal=1'; 
           // demo = WEBPLAY_PAGE+'?play='+item.simple_name+'&forreal=0';  
            games2 += '<li class="gameimage"><div class="games-wrap"><a href="'+real+'"> <div class="s-card"><div class="s-card-head"><img src="'+ASSETSDOMAINJS+'/rtg/portrait/'+item.simple_name+'.jpg" alt="'+item.name+'"></div><div class="s-card-body"><h2>'+item.name+'</h2><p>'+item.category+'</p></div></div></a></li>';  
            i++;
          });	
          targetElement.innerHTML = '<ul>'+games2+'</ul>';		
        }
    })


}

function showOriginalSearchPage(){
    loaderDiv.style.display = "none"; // hide the div
    let search = document.getElementById("search");
    closeicon.style.display = "none";
    search.value = '';
    GamessearchLoad();
}
showOriginalSearchPage();